
import type { PropType } from 'vue'
import type { TimeSlotChildren } from '@/new-services/types/time-slots'

import { defineComponent } from 'vue'

import TimeSlotItemResources from './TimeSlotItemResources.vue'
import TimeSlotItemSectors from './TimeSlotItemSectors.vue'

export default defineComponent({
    components: {
        TimeSlotItemResources,
        TimeSlotItemSectors
    },
    props: {
        child: {
            type: Object as PropType<TimeSlotChildren>,
            required: true
        }
    },
    emits: ['change-status'],
    setup(props, { emit }) {
        const onChangeStatus = () => emit('change-status', { timeSlotId: props.child.id, statusId: props.child.status.id })
        const format = (timeStr: string) => timeStr.substring(0, 5)

        const getPeriod = (periodStart: string, periodEnd: string) => {
            let periodEndHours = Number(periodEnd.split(':')[0])

            if (periodEndHours === 23) {
                return `${periodStart} — 00:00`
            }

            periodEndHours = periodEndHours + 1

            return `${periodStart} — ${periodEndHours.toString().padStart(2, '0')}:00`
        }

        return {
            format,
            getPeriod,
            onChangeStatus
        }
    }
})
